import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const metricasTurnosMotivosTurnoClientes = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SUPERVISOR.METRICAS.CLIENTES_MOTIVOS_TURNO}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default metricasTurnosMotivosTurnoClientes;